import React from "react";

/**
 * Shared card container — Stitch soft card (12px radius, Cloud Mist border).
 * Variants: mist | white | elevated
 */
const variants = {
  mist: "bg-mist-soft border border-cloud-mist shadow-brand-sm",
  white: "bg-surface-white border border-cloud-mist shadow-brand-sm",
  elevated: "bg-surface-white border border-cloud-mist shadow-brand-md",
};

const Card = ({
  children,
  variant = "mist",
  as: Tag = "div",
  className = "",
  ...rest
}) => {
  return (
    <Tag
      className={`rounded-brand p-7 text-left ${variants[variant] || variants.mist} ${className}`.trim()}
      {...rest}
    >
      {children}
    </Tag>
  );
};

export default Card;
